import React from 'react';
import aboutimg from '../assets/images/about-company.jpg';

const About = () => {
  return (
    <div id="About">
      <section className="about-area sec-padding mt-5">
        <div className="container">
          <div className="section-title">
            <h2>About Us</h2>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="img-holder">
                <img 
                  decoding="async" 
                  className="img-fluid mb-3" 
                  src={aboutimg}
                  alt="Awesome Image" 
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="text-holder">
                <div className="top-text">
                  <h5 style={{color:'#48c7ec',fontWeight:'bold'}}>Empowering businesses with expert IT solutions, staffing, training, and technical support to drive growth and innovation.
                  </h5>
                  <p>
                  At our Saha Infotechs, we specialize in helping clients meet their technology needs through personalized, innovative solutions. Our goal is to bridge the gap between businesses and technology by providing skilled professionals to fill open positions. Our consultants also offer valuable training programs aimed at equipping your staff with the skills they need to stay ahead in the fast-paced world of technology.
                  </p>
                  <div className="bottom-text">
                  <p>
                  In addition to our IT solutions and staffing services, we pride ourselves on offering comprehensive technical support to ensure your systems run smoothly and efficiently. Our team of experts is dedicated to resolving issues promptly, minimizing downtime, and optimizing your business operations. By partnering with Saha Infotechs, you gain access to cutting-edge technology and a dedicated support network, enabling your business to stay competitive and future-ready. Whether you're looking to enhance your workforce capabilities or streamline your IT infrastructure, we provide the resources and expertise to help you thrive in today's digital landscape.                  </p>
                </div>
               </div>
                 
              
              </div>
            </div>
          </div>
          <div className="promotion-box mt-5">
            <div className="row">
              <div className="col-md-4">
                <div className="singel-box hvr-float mt-3">
                  <div className="top">
                    <div className="icon-holder">
                      <span className="fa fa-lightbulb"></span>
                    </div>
                    <div className="title-holder">
                      <h3>Client-Centric Approach</h3>
                    </div>
                  </div>
                  <div className="text-holder">
                    <p>
                    We prioritize understanding your unique business needs, offering tailored IT solutions that ensure long-term success and growth. Your goals are our roadmap for success.

                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="singel-box hvr-float  mt-3">
                  <div className="top">
                    <div className="icon-holder">
                      <span className="fa fa-certificate"></span>
                    </div>
                    <div className="title-holder">
                      <h3>Experienced Consultants</h3>
                    </div>
                  </div>
                  <div className="text-holder">
                    <p>
                    Our team of seasoned professionals brings industry-leading expertise, providing strategic insights and hands-on support to navigate complex IT challenges and drive innovation.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="singel-box hvr-float  mt-3">
                  <div className="top">
                    <div className="icon-holder">
                      <span className="fa fa-briefcase"></span>
                    </div>
                    <div className="title-holder">
                      <h3>Proven Results</h3>
                    </div>
                  </div>
                  <div className="text-holder">
                    <p>
                    With a track record of delivering impactful solutions, we consistently help businesses optimize their IT systems and achieve measurable outcomes that improve efficiency and performance.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="whychoos-us sec-padd2 mt-5">
        <div className="container">
          <div className="section-title center">
            <h2>Why Choose Us</h2>
            <div className="text">
              <p>
              Delivering innovative IT solutions and expert guidance to drive your business forward.
              </p>
            </div>
          </div>
          <div className="row clearfix">
            <article className="column col-md-4 col-sm-6 col-xs-12">
              <div className="item">
                <div className="icon_box">
                  <span className="icon-graphic2"></span>
                </div>
               
                <h4> <i className="fa fa-chart-line" style={{color:'#48c7ec'}}></i> Drive Efficiency and Innovation</h4>
                <div className="text">
                  <p>
                  Leverage cutting-edge technology and expert strategies to streamline operations, boosting productivity and fostering innovation. Our solutions empower your business to stay ahead of the curve.
                  </p>
                </div>
              </div>
            </article>
            <article className="column col-md-4 col-sm-6 col-xs-12">
              <div className="item">
                <div className="icon_box">
                  <span className="icon-layers"></span>
                </div>
                <h4><i className="fa fa-layer-group" style={{color:'#48c7ec'}}></i> Save Time and Resources</h4>
                <div className="text">
                  <p>
                  By optimizing processes and automating tasks, we help you reduce operational costs and improve resource allocation. Focus on growth while we handle the technical complexities.
                  </p>
                </div>
              </div>
            </article>
            <article className="column col-md-4 col-sm-6 col-xs-12">
              <div className="item">
                <div className="icon_box">
                  <span className="icon-computer"></span>
                </div>
                <h4>  <i className="fa fa-users"style={{color:'#48c7ec'}}></i> Achieve Results Faster</h4>
                <div className="text">
                  <p>
                  With our expert consulting, you can implement solutions swiftly and effectively, ensuring quicker project completion and faster time-to-market. Let us accelerate your success.
                  </p>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default About;
